<template>
  <div class="head-item">
    <div class="head-item-top c-c">
      <div class="flex1 c-l">
        <div @click="goToShop" v-if="mes.shop.has_shop == 1" class="main-pic">
          <img
            :src="
              mes.publisher.avatar_url
                ? mes.publisher.avatar_url
                : 'http://cdn11.jfbst.com/statics/head2.gif'
            "
          />
          <img src="../assets/images/images/plus.png" />
        </div>
        <div v-else class="main-pic">
          <img
            :src="
              mes.publisher.avatar_url
                ? mes.publisher.avatar_url
                : 'http://cdn11.jfbst.com/statics/head2.gif'
            "
          />
        </div>
        <div class="main-tag c-c-l f-d-c">
          <div class="tag-small c-c">
            <div style="position: relative;" v-if="mes.svip_level.vip + mes.svip_level.svip">
              <img src="../assets/images/images/svipImg.png" alt />
              <div class="vip-dengji">{{mes.svip_level.vip + mes.svip_level.svip}}</div>
            </div>
          </div>
          <div class="f11 t128" style="text-align: left">
            {{
              mes.publisher.nickname == "无"
                ? "IP：" + mes.ip_hidden
                : mes.publisher.nickname
            }}
          </div>
        </div>
      </div>
      <!--店铺信息-->
      <div
        class="shopBtn"
        v-if="mes.shop.has_good == 1 && pics.length > 0"
        @click="goToShop2"
      >
        店铺主页
      </div>
      <div class="phone">
        <a :href="relPhone">
          <img v-if="mes.phone" src="../assets/images/images/tel_1.gif" alt />
        </a>
        <img v-if="!mes.phone" src="../assets/images/images/noPhone.png" alt />
      </div>
    </div>
    <div class="main-mes van-hairline--bottom">
      <span
        class="t-l c-l f15"
        style="width: 100%"
        @click="toggleShow(mes.content)"
        v-toggleContent="mes.is_recommend"
        >{{ content }}</span
      >
    </div>
    <div class="c-c head-item-bottom">
      <div class="c-l flex1 f11 one-hour">{{ mes.published_time }}</div>
      <div class="flex1 c-c">
        <div
          class="man-pic"
          v-for="(item, index) in pics"
          :key="index"
          @click="previewPic(index)"
        >
          <img :src="item" alt />
        </div>
      </div>
      <div
        v-if="showClose"
        style="
          position: fixed;
          bottom: 100px;
          left: 0px;
          width: 100%;
          display: flex;
          justify-content: center;
          z-index: 9999;
        "
      >
        <img
          @click="closeImg"
          style="width: 30px; height: 30px"
          src="../assets/images/images/close.png"
          alt
        />
      </div>
      <div @click="warn()" class="c-end flex1 f11 one-hour">纠错/举报</div>
    </div>
    <!-- <DrawUp :class="showDrawUp == true? 'Sh': 'Hi'" @close="close"></DrawUp> -->
    <template v-if="actions.length">
      <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />
    </template>
    <div class="pp">
      <van-image-preview
        v-model="showPreview"
        :images="images"
      ></van-image-preview>
    </div>
  </div>
</template>

<script>
let instance;
import { ActionSheet } from "vant";
import { ImagePreview } from "vant";
import { getData } from "../Interface/http.js";
import { postData } from "../Interface/http.js";
import DrawUp from "./DrawUp";
export default {
  name: "HeadItem",
  data() {
    return {
      showClose: false,
      images: [],
      realImages: [],
      realSmallImages: [],
      showPreview: false,
      showDrawUp: false,
      show: false,
    };
  },
  mounted() {},
  computed: {
    actions() {
      let arr = [];
      if (this.$store.state.nowActions !== "[]") {
        arr = this.$store.state.nowActions;
      } else {
        arr = JSON.parse(sessionStorage.getItem("nowActions"));
      }
      let arr1 = [];
      if (arr.length != 0) {
        for (let a = 0; a < arr.length; a++) {
          let id = arr[a].id;
          let name = arr[a].title;
          arr1.push({ id: id, name: name });
        }
      }
      return arr1;
    },
    content() {
      return this.mes.content;
    },
    relPhone() {
      return this.mes.phone ? "tel:" + this.mes.phone : "";
    },
    pics() {
      if (this.mes.thumbs.length != 0) {
        this.realImages = [];
        this.realSmallImages = [];
        for (let a = 0; a < this.mes.thumbs.length; a++) {
          this.realImages.push(this.mes.thumbs[a].path_url);
          this.realSmallImages.push(this.mes.thumbs[a].small_path_url);
        }
        this.images = this.realImages;
        return this.realSmallImages.slice(0, 3);
      } else {
        // return this.images;
      }
    },
  },
  methods: {
    closeImg() {
      this.showClose = false;
      if (instance) {
        instance.close();
      }
    },
    goToShop2() {
      this.$store.commit("UPDATEATBINDEX", { tag: 7 });
      let me = this;
      me.$router.push({
        name: "shopDetailInfo",
        query: {
          type: "goods",
          id: me.mes.shop.id,
        },
      });
    },
    goToShop() {
      this.$store.commit("UPDATEATBINDEX", { tag: 7 });
      let me = this;
      me.$router.push({
        name: "shopDetailInfo",
        query: {
          type: "info",
          id: me.mes.shop.id,
        },
      });
    },
    previewPic(index) {
      this.showClose = true;
      instance = ImagePreview({
        images: this.images,
        asyncClose: true,
        startPosition: index,
      });
    },
    onSelect(item) {
      let param = {
        message_id: this.mes.id - 0,
        option_id: item.id - 0,
      };

      postData("/report", param)
        .then((res) => {
          this.show = false;
          this.$toast("纠错成功");
        })
        .catch((err) => {
          this.show = false;
          this.$toast("纠错失败,请加客服对接!");
        });
    },
    getList() {
      getData("/recommend-lists", {}).then((res) => {});
    },
    toggleShow(index) {},
    warn() {
      this.show = true;
    },
    close() {
      this.showDrawUp = false;
    },
  },
  beforeDestroy() {
    this.closeImg();
  },
  props: ["mes"],
  directives: {},
  components: {
    DrawUp,
  },
};
</script>

<style scoped>
.pp {
  width: 100%;
  height: 50%;
}
.head-item {
  width: 100%;
  /* height:343px; */
  background: #fff;
  margin-top: 3px;
  padding: 8px 12px 0px 16px;
  box-sizing: border-box;
  border-radius: 5px;
}
.head-item-top {
  width: 100%;
}
.phone {
  width: 20px;
  height: 20px;
}
.man-pic {
  width: 34px;
  height: 34px;
  margin-right: 5px;
  overflow: hidden;
  position: relative;
}
.man-pic img {
  width: auto !important;
  height: auto !important;
  max-width: 3rem;
  min-height: 34px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
.head-item-bottom {
  height: 45px;
}
.main-mes {
  font-size: 12px;
  color: rgb(51, 51, 51);
  padding: 13px 0 12px 0;
}
.one-hour {
  color: rgb(143, 143, 143);
}
.vip-dengji { margin: 0 !important;
  position: absolute;
  width: fit-content !important;
  right: 1px;
  bottom: 3px;
  font-size: 12px;
  color: #fff;
}
.main-pic {
  width: 29px;
  height: 29px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.main-pic img {
  border-radius: 5px;
}
.main-pic img:nth-child(2) {
  width: 15px;
  height: 15px;
  margin-top: -7px;
}
.main-tag {
  margin-left: 4px;
}
.t128 {
  color: rgb(128, 128, 128);
  margin-top: 3px;
  width: 7rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tag-small div {
  width: 13px;
  height: 13px;
  margin-right: 3px;
}
.Sh {
  display: block;
}
.Hi {
  display: none;
}
.shopBtn {
  width: 56px;
  height: 22px;
  font-size: 11px;
  color: #892785;
  text-align: center;
  display: inline-block;
  line-height: 22px;
  border: 1px solid #892785;
  border-radius: 6px;
  margin-right: 12px;
}
</style>
